import { render, staticRenderFns } from "./SnssaiTable.vue?vue&type=template&id=fc1e2b38&scoped=true&"
import script from "./SnssaiTable.vue?vue&type=script&lang=js&"
export * from "./SnssaiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1e2b38",
  null
  
)

export default component.exports